import React = require('react');
import {IQuestion} from './models';
import {Choice} from "./Choice";
import {IFilterChoices} from "./models";
import {IChoice} from "./models";
import Immutable = require('immutable');
import {AsyncPost} from "./utils";
import {AsyncPostStatus} from "./utils";
import {ContactFormData} from "./models";
import {FormGroup} from './FormGroup';
import {validateContactFormData} from "./validation";
import {Dictionary} from "./utils";
import {countValidationErrors} from "./gapi";
import {ContactFormRequest} from "./models";

declare const window;

interface Properties {
}

interface Callbacks {
}

interface Props extends Properties, Callbacks {}

interface State {
    postData: AsyncPost<ContactFormData,any>,
    validationErrors: Dictionary<string[]>
}

export class ContactForm extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            postData: {
                status: AsyncPostStatus.NONE,
                data: null
            },
            validationErrors: {}
        }
    }

    private trackConversion() {
        window.goog_report_conversion("OaH6CKO_5G0Q1Lad3wM");
    }

    handleSubmit(event) {

        event.preventDefault();

        if (this.state.postData.status == AsyncPostStatus.POSTING || this.state.postData.status == AsyncPostStatus.POSTED) {
            // The form is currently being posted or was posted so we don't do anything
            return;
        }

        var formData = Immutable.List( $(this.refs["form"]).serializeArray() )
            .reduce( (map, obj: any) => map.set(obj.name, obj.value), Immutable.Map() )
            .toJS();

        var errors = validateContactFormData(formData);

        if (Immutable.Map(errors).size > 0) {

            // There are some validation errors so we don't proceed
            this.setState(
                Immutable.Map(this.state)
                    .set('validationErrors', errors)
                    .toJS()
            );

        } else {

            // perform ajax request
            this.setState(
                Immutable.fromJS(this.state)
                    .set('validationErrors', {})
                    .setIn(['postData', 'status'], AsyncPostStatus.POSTING)
                    .setIn(['postData', 'data'], formData)
                    .toJS()
            );

            var postData: ContactFormRequest = Immutable.Map(formData)
                .set('hostname', window.location.hostname)
                .toJS();

            $.ajax({
                type: 'POST',
                url: 'https://t4180mk7s3.execute-api.eu-west-1.amazonaws.com/prod/ContactFormRequest-dev',
                //url: 'https://t4180mk7s3.execute-api.eu-west-1.amazonaws.com/dev/CellClinicSubmitForm-dev',
                data: JSON.stringify(postData),
                contentType: "application/json",
                dataType: 'json'
            }).done((resp) => {

                if (resp && resp.errorMessage) {
                    this.setState(
                        Immutable.fromJS(this.state)
                            .setIn(['postData', 'status'], AsyncPostStatus.ERROR)
                            .setIn(['postData', 'error'], 'Failed to send message. Please try again.')
                            .toJS()
                    );
                } else {
                    this.setState(
                        Immutable.fromJS(this.state)
                            .setIn(['postData', 'status'], AsyncPostStatus.POSTED)
                            .toJS()
                    );

                    this.trackConversion();
                }

            }).fail( () => {
                this.setState(
                    Immutable.fromJS(this.state)
                        .setIn(['postData', 'status'], AsyncPostStatus.ERROR)
                        .setIn(['postData', 'error'], 'Failed to send message. Please try again.')
                        .toJS()
                );
            })

        }
    }

    render() {
        var sendButtonContent;
        if (this.state.postData.status == AsyncPostStatus.POSTING) {
            sendButtonContent = <button type="submit" className="cc-contact-form__submit-btn btn btn-success btn-lg btn-cc-green disabled" onClick={this.handleSubmit.bind(this)}>Sending ..</button>
        } else if (this.state.postData.status == AsyncPostStatus.POSTED) {
            sendButtonContent = <div>
                <div>
                    <p className="text-success">Thank you for contacting us. Our team will get in touch with you as soon as possible.</p>
                    <button className="cc-contact-form__submit-btn btn btn-success btn-lg btn-cc-green disabled" onClick={this.handleSubmit.bind(this)}>
                        <i className="glyphicon glyphicon-ok"/> Sent
                    </button>
                </div>
            </div>
        } else if (this.state.postData.status == AsyncPostStatus.ERROR) {
            sendButtonContent = <div>
                <p className="text-danger">{this.state.postData.error}</p>
                <button type="submit" className="cc-contact-form__submit-btn btn btn-success btn-lg btn-cc-green" onClick={this.handleSubmit.bind(this)}>Send</button>
            </div>
        } else {
            sendButtonContent = <button type="submit" className="cc-contact-form__submit-btn btn btn-success btn-lg btn-cc-green" onClick={this.handleSubmit.bind(this)}>Send</button>
        }

        var disabled = this.state.postData.status == AsyncPostStatus.POSTING;

        return <div className="cc-contact-form">
            <form ref="form">
                <div className="row">
                    <div className="col-xs-12">

                        <FormGroup errors={this.state.validationErrors['name']}>
                            <label htmlFor="inputName">Your Name</label>
                            <input type="text" name="name" className="form-control" id="inputName" placeholder="Name" disabled={disabled} />
                        </FormGroup>
                        <FormGroup errors={this.state.validationErrors['email']}>
                            <label htmlFor="inputEmail">Your Email Address</label>
                            <input type="email" name="email" className="form-control" id="inputEmail" placeholder="Email Address" disabled={disabled} />
                        </FormGroup>
                        <FormGroup errors={this.state.validationErrors['subject']}>
                            <label htmlFor="inputSubject">Subject</label>
                            <input type="text" name="subject" className="form-control" id="inputSubject" placeholder="Subject" disabled={disabled} />
                        </FormGroup>
                        <FormGroup errors={this.state.validationErrors['message']}>
                            <label htmlFor="inputMessage">Message</label>
                            <textarea rows={10} name="message" className="form-control" id="inputMessage" placeholder="Message" disabled={disabled} />
                        </FormGroup>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12 text-center">
                        {sendButtonContent}
                    </div>
                </div>
            </form>

        </div>;
    }
}
